import { useRef } from 'react';
import { FormState } from '../useFormState';
import { FormSchemaConfig } from '../../types';
import { SectionKey } from '../../../../../types';

export const useFormRefs = (formState: FormState) => {
  const refs = {
    prevData: useRef(formState.data),
    prevSection: useRef(formState.currentSection),
    prevSchema: useRef<FormSchemaConfig | null>(null),
    updatesInProgress: useRef(false),
    reassignmentInProgress: useRef(false),
    prevSectionState: useRef({
      section: null as SectionKey | null,
      timestamp: Date.now(),
    }),
  };

  return refs;
};
